"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
/**
 * Transforming text style object to font style.
 */
var TextStyleToFontStylePipe = /** @class */ (function () {
    function TextStyleToFontStylePipe() {
    }
    TextStyleToFontStylePipe_1 = TextStyleToFontStylePipe;
    TextStyleToFontStylePipe.getFontName = function (fontName) {
        switch (fontName) {
            case idm_report_export_service_client_js_1.FontName.ARIAL:
                return 'Arial';
            case idm_report_export_service_client_js_1.FontName.TAHOMA:
                return 'Tahoma';
            case idm_report_export_service_client_js_1.FontName.VERDANA:
                return 'Verdana';
            case idm_report_export_service_client_js_1.FontName.TIMES_NEW_ROMAN:
                return 'Times New Roman';
        }
    };
    TextStyleToFontStylePipe.getAlignName = function (align) {
        switch (align) {
            case idm_report_export_service_client_js_1.Align.LEFT:
                return 'left';
            case idm_report_export_service_client_js_1.Align.CENTER:
                return 'center';
            case idm_report_export_service_client_js_1.Align.RIGHT:
                return 'right';
        }
    };
    TextStyleToFontStylePipe.prototype.transform = function (textStyle) {
        if (!textStyle) {
            return {};
        }
        var fontStyle = {};
        fontStyle.align = TextStyleToFontStylePipe_1.getAlignName(textStyle.align);
        fontStyle.backgroundColor = textStyle.backgroundColor;
        fontStyle.color = textStyle.color;
        fontStyle.fontName = TextStyleToFontStylePipe_1.getFontName(textStyle.fontName);
        fontStyle.fontSize = textStyle.fontSize;
        fontStyle.isBold = textStyle.isBold;
        fontStyle.isItalic = textStyle.isItalic;
        fontStyle.isUnderline = textStyle.isUnderline;
        return fontStyle;
    };
    var TextStyleToFontStylePipe_1;
    TextStyleToFontStylePipe = TextStyleToFontStylePipe_1 = __decorate([
        core_1.Pipe({
            name: 'toFontStyle',
            pure: true
        }),
        __metadata("design:paramtypes", [])
    ], TextStyleToFontStylePipe);
    return TextStyleToFontStylePipe;
}());
exports.TextStyleToFontStylePipe = TextStyleToFontStylePipe;
//# sourceMappingURL=text-style-to-font-style.pipe.js.map